<template>
  <a-modal
    width="900px"
    :title="`确认${name}`"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div>
      根据已填写信息，{{name}}合计如下:
    </div>
    <br>
    <h3>{{name}}合计</h3>
    <div class="result">
      <a-row type="flex"  align="middle" :gutter="24" >
        <div v-for="(el,index) in confirmResultList" :key="index" class="cBox">
          <a-col :span="12" >
            <div class="title">{{el.title}}</div>
          </a-col>
          <a-col :span="12" >
            <div class="box">
              <!-- {{confirmResult[el.field]?.toFixed(el.field.indexOf('Num') >= 0 ? 0 : 2) || '-'}} -->
              {{ confirmResult[el.field] ? Number(confirmResult[el.field] || 0).toFixed(el.field.indexOf('Num') >= 0 ? 0 : 2) : '-'}}
            </div>
          </a-col>
        </div>
      </a-row>
    </div>
    </a-modal>
</template>

<script>
export default {
  props:['visible','name','confirmResultList','confirmResult'],
  data(){
    return{}
  },
  methods:{
    handleOk() {
      this.$emit('isShow', false)
      this.$emit('confirm')
    },
    handleCancel() {
      this.$emit('isShow', false)
    },
  }
}
</script>

<style lang='scss'>
.cBox{
  width: 50% 
}
.result{
  background-color:whitesmoke;
  padding: 3px;
  .title{
    padding: 5%;
    margin: 1px;
    width:110%;
  }
  span{
    margin-left: 10px;
  }
  .box{
    background-color: white;
    padding: 5%;
    margin: 1px;
    width:100%;
    text-align: center;
  }
}
</style>